import React from "react";
import "./banner.css";
import { Link ,useNavigate} from "react-router-dom";
import LeftIcon from "../../../Assets/Icons/LeftIcon";

const BannerSection = () => {
  const navigate = useNavigate();
  return (
    <div className="sp-banner">
      <div className="sp-banner-content maxWidth-content">
        
        <Link onClick={()=>navigate(-1)}>
          <LeftIcon />
        </Link>
        <h1>School Programs</h1>
       
      </div>
    </div>
  );
};

export default BannerSection;
